export const BOOST_CLICK = 'BOOST_CLICK';

export const EVENT_TYPE_IDS = {
    BOOST_CLICK: '2521',
};

export const EVENT_TYPE_VERSION_ID = {
    BOOST_CLICK: '3',
};

export const EVENT_TEMPLATE_IDS = {
    BOOST_CLICK: '16',
};

export const TRIGGER_TYPE_NM = {
    BOOST_CLICK: 'interaction',
};

export const TRIGGER_OBJECT_NM = {
    BOOST_CLICK: 'search_results',
};

export const TRIGGER_SOURCE_NM = {
    BOOST_CLICK: 'button_to_see_ad',
};

export const TRIGGER_LOCATION_NM = {
    BOOST_CLICK: 'search_results',
};

export const SEMANTIC_EVENT_NM = {
    BOOST_CLICK: 'view_content',
};

export const TOPIC_TAG_TXT = {
    BOOST_CLICK: ['ad_targeting'],
};
